import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=7142cb3b&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"
import style0 from "./ConfirmOrder.vue?vue&type=style&index=0&id=7142cb3b&prod&lang=css"
import style1 from "./ConfirmOrder.vue?vue&type=style&index=1&id=7142cb3b&prod&lang=scss&scoped=true"
import style2 from "./ConfirmOrder.vue?vue&type=style&index=2&id=7142cb3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142cb3b",
  null
  
)

export default component.exports